import { useEffect, useState } from "react";
import LoadingSpinner from "../../../../../sharedComponents/LoadingSpinner/LoadingSpinner";
import { Avatar, IconButton, List , ListItem, ListItemAvatar, ListItemButton, ListItemText } from "@mui/material";
import DescriptionIcon from '@mui/icons-material/Description';
import axios from "axios";
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Modal } from "react-bootstrap";
import CancelButton from "../../../../../sharedComponents/cancelButton/CancelButton";
import { Link } from "react-router-dom";

//delete auch von allen Mitarbeitern

function AreaList(){

    const [isLoading, setIsLoading] = useState(true);
    const [areas, setAreas] = useState(null);

    const [deleteModalState, setDeleteModalState] = useState({
        isOpen: false,
        itemId: null
    });

    const closeDeleteModal = () => setDeleteModalState({
        isOpen: false,
        itemId: null
    });

    const openDeleteModal = (itemId) => {
        setDeleteModalState({
            isOpen: true,
            itemId: itemId
        });
    };

    useEffect(() => {
        getAreas();
    }, [])

    function getAreas(){
        axios.get('area').then(results => {
            setAreas(results.data);
            setIsLoading(false);            
        })
    }

    const deleteArea = () => {
        axios.delete('area/' + deleteModalState.itemId).then(() => {
            closeDeleteModal();
            getAreas();          
        }).catch((error => {
            console.log(error);            
        }))
    }

    function DeletingModal() {
        return (
            <Modal
                show={deleteModalState.isOpen}
                onHide={closeDeleteModal}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header>
                    <Modal.Title>Bereich löschen</Modal.Title>
                    <button type="button" className="close" aria-label="Close" onClick={closeDeleteModal}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <p>Möchten Sie wirklich den Bereich löschen? Dieser Bereich wird auch von allen Mitarbeitern entfernt.</p>
                </Modal.Body>
                <Modal.Footer>
                    <CancelButton text="Abbrechen" onClick={closeDeleteModal} />
                    <Button variant="danger" onClick={deleteArea}>Bereich löschen</Button>
                </Modal.Footer>
            </Modal>
        )
    }

    function getAreaItems(){
        if (areas.length === 0) {
            return <p>Keine Regelungen.</p>
        } 
        
        return areas.map((item, index) => (
            <ListItem key={index}
                secondaryAction={
                <IconButton edge="end" aria-label="delete" onClick={() => openDeleteModal(item.id)} >
                    <DeleteIcon />
                </IconButton>
            }>                    
                <ListItemButton component={Link} to={'detailView?id=' + item.id}>
                    <ListItemAvatar>
                        <Avatar>
                            <DescriptionIcon />
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText primary={item.name} />
                </ListItemButton>                    
            </ListItem>
        ))
    }

    return (
        <>
            {isLoading ? (
                <LoadingSpinner />
            ) : (
                <List sx={{ width: '100%', maxWidth: 360 }}>
                    {getAreaItems()}
                </List>
            )}
            <DeletingModal />
        </>
    )
}

export default AreaList;